import { render, staticRenderFns } from "./NbSwitch.vue?vue&type=template&id=1a0d6a4f&"
import script from "./NbSwitch.vue?vue&type=script&lang=js&"
export * from "./NbSwitch.vue?vue&type=script&lang=js&"
import style0 from "./NbSwitch.vue?vue&type=style&index=0&id=1a0d6a4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports